import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectDocumentUpload = createSelector([(state: AppState) => state.shared.documentUpload], ({ url, processing }) => ({
  url,
  processing,
}));
